<template>
  <a-select :value="selectedItems" show-search style="width:100%" :default-active-first-option="false" v-bind='$attrs' :show-arrow="false" :placeholder="placeholder" :filter-option="false" @change="handleChange" :not-found-content="null" @search="handleSearch">
    <a-select-option v-for="(item, index) in items" :key="index" :value="item.value">
      {{ item.label }}
    </a-select-option>
  </a-select>
</template>
<script>
import { getAction } from '@/api/manage'
export default {
  props: {
    url: String, //请求的地址
    value: String, //传进的来id名称
    parameter: String, //对应的参数名
    asterisk: Boolean, //是否加星号筛选
    ShowRecords: Boolean, //是否列表返回加records
    placeholder: String, //空值提示
    showItem: {
      //选择框是否本身
      type: Boolean,
      required: false,
      default: false
    },
    params: {
      //请求另外携带的参数
      type: Object,
      required: false,
      default: {}
    },
    showType: Boolean,//是否现在不一样的名称
    showTypeName: String,//显示的中文
    showTypeValue: String,//显示key值
  },
  data() {
    return {
      items: '',
      selectedItems: '',
      ipagination: {
        pageNo: 1,
        pageSize: 10,
        column: 'createTime',
        order: 'desc'
      },
      total: 21, //总长度
      spinning: true
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        console.log(val)
        if (val) {
          this.selectedItems = val;
        } else {
          this.selectedItems = ''
        }
      }
    },
    url: {
      immediate: true,
      handler(val) {
        this.initDictData()
      }
    },
    parameter: {
      immediate: true,
      handler(val) {
        this.ipagination[val] = ''
      }
    },
    params: {
      immediate: true,
      handler(val) {
        Object.assign(this.ipagination, val)
      }
    }
  },
  components: {
    VNodes: {
      functional: true,
      render: (h, ctx) => ctx.props.vnodes
    }
  },
  methods: {
    handleChange(value) {
      let that = this
      this.$emit('input', value)
      this.$emit('change', value)
      this.selectedItems = value
      this.items.forEach(item => {
        if (item.value == value) {
          that.$emit('callBack', item)
        }
      })

      console.log(value) // { key: "lucy", label: "Lucy (101)" }
    },
    initDictData() {
      let that = this
      that.spinning = true
      getAction(that.url, that.ipagination).then(res => {
        console.log(res.result)
        that.spinning = false
        if (res.success) {
          let result = res.result
          if (that.ShowRecords) {
            result = res.result.records
          }
          that.items = result.map((item, index) => {
            if (that.showItem) {
              let obj = {
                value: item,
                label: item
              }
              return obj
            }
            if (that.showType) {
              item.label = item[this.showTypeName];
              item.value = item[this.showTypeValue];
            }
            return item
          })
          that.items.forEach(item => {
            if (that.showItem && item.value == that.value && that.value) {
              that.selectedItems = item.value
              that.handleChange(item.value)
            } else if (item[that.showTypeValue] == that.value && that.value) {
              that.selectedItems = item.value
              that.handleChange(item.value)
            }
          })
          that.total = res.result.length
        }
      })
    },
    handleSearch(value) {
      this.ipagination.pageSize = 10
      if (this.asterisk) {
        this.ipagination[this.parameter] = `*${value}*`
      } else {
        this.ipagination[this.parameter] = value
      }
      this.initDictData()
      console.log(value)
    },
    addItem() {
      console.log('addItem')
      this.ipagination.pageSize += 10
      this.initDictData()
      // this.items.push(`New item ${index++}`);
    }
  }
}
</script>
<style lang="less">
.spin-content {
  border: 1px solid #91d5ff;
  background-color: #e6f7ff;
  padding: 30px;
}
.more-box {
  margin: 0 !important;
}
.spinning-box > div > .ant-spin {
  /* max-height: 100% !important; */
  position: absolute !important;
}
</style>
